export function SwipeMore() {
  return (
    <div className="fixed z-50 bottom-44 sm:bottom-36 inset-x-1/2  text-xs whitespace-nowrap -translate-x-20">
      <span className="bg-accent px-4 py-2 rounded-lg text-white bg-opacity-5 text-opacity-60">
        Swipe/Scroll Down
      </span>
    </div>
  );
}
